// src/services/propFirmApi.js

import api from "@/lib/api";

export const createBlog = async (formData) => {
    const res = await api.post("/blogs/create", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

    return res.data;
};

export const getBlogById=async({blog_id})=>{
    try {
        const res=await api.get(`/blogs/${blog_id}`)
        console.log(res)
    } catch (error) {
        console.log(error)
    }
}

export const deleteBlog=async({blog_id})=>{
    try {
        const res=await api.delete(`/blogs/delete/${blog_id}`)
        console.log("firm is deleted",res)
    } catch (error) {
     console.log(error)   
    }
}